import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

export interface ModalResult<T> {
  modal: NgbModalRef;
  component: T;
}
